/**
 * PreviewListRankControls — the panel's one control row.
 *
 * Everything that used to be four rows of chips (sort / rank / status /
 * outcome / pool) now lives behind a single sliders icon, so the list starts
 * at the top of the panel instead of a third of the way down. The row also
 * carries the "viewing <path>" chip, which is the only way back out of the
 * landers/offers drill-down.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import { X } from 'lucide-react';

import { PreviewFilterMenu } from './filters';
import type { PreviewFilterMenuProps } from './filters';

export interface PreviewListRankControlsProps extends PreviewFilterMenuProps {
  /** Name of the drilled-into path, when one is selected. */
  selectedPathName?: string;
  onClearPath?: () => void;
}

const PreviewListRankControls: FC<PreviewListRankControlsProps> = ({
  selectedPathName,
  onClearPath,
  ...filters
}) => (
  <div className="flex items-center gap-2 px-0.5 pb-1">
    <PreviewFilterMenu {...filters} />
    {onClearPath ? (
      <button
        type="button"
        onClick={onClearPath}
        aria-label="Back to all paths"
        title="Back to all paths"
        className="inline-flex h-6 min-w-0 items-center gap-1 rounded-md border border-primary/40 bg-primary/10 px-1.5 text-[10px] text-foreground transition-colors hover:bg-primary/20"
      >
        <span className="truncate">{selectedPathName?.trim() || 'Selected path'}</span>
        <X className="h-3 w-3 shrink-0" aria-hidden />
      </button>
    ) : (
      <span className="truncate text-[10px] text-muted-foreground">
        Click a path to see its landers &amp; offers
      </span>
    )}
  </div>
);

export default PreviewListRankControls;
